/* src/app/private/components/reports/lead-report-details/lead-report-details.component.scss */
/*# sourceMappingURL=lead-report-details.component.css.map */
